module.exports = __webpack_public_path__ + "app/principal/subentity-details-347TX8dg.html";